import { render, staticRenderFns } from "./xd.vue?vue&type=template&id=52b52b0e&"
import script from "./xd.vue?vue&type=script&lang=js&"
export * from "./xd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports